<template>
  <div class="shipping-label-wrapper">
    <div class="shipping-label">
      <!-- Header -->
      <div class="header">
        <div class="store">
          <img
            v-if="storeLogo"
            :src="storeLogo"
            alt="Store Logo"
            class="store-logo"
          >

          <div class="store-info">
            <span class="store-name">
              {{ storeName }}
            </span>

            <span class="store-field">
              {{ customField1 }}
            </span>

            <span class="store-field">
              {{ customField2 }}
            </span>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <!-- QR -->
      <div class="qr-section">
        <div class="qr-content">
          <img
            :src="qrSvg"
            alt="QR"
            class="qr-image"
          >

          <span class="tracking-code">
            {{ trackingCode }}
          </span>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Destinatario -->
      <div class="recipient">
        <span class="recipient-commune">
          {{ recipient.commune }}
        </span>

        <span class="recipient-text">
          {{ recipient.address }}
        </span>

        <span class="recipient-label">
          Destinatario
        </span>

        <span class="recipient-text">
          {{ recipient.name }}
        </span>

        <span class="recipient-text">
          Tel: {{ recipient.phone }}
        </span>
      </div>

      <div class="divider"></div>

      <!-- Footer -->
      <div class="footer">
        <div>
          <span class="footer-label">
            Gestionado por
          </span>

          <span class="footer-title">
            EnvíosNOW
          </span>

          <span class="footer-user">
            @envios.now
          </span>
        </div>

        <img
          src="/logo-label.png"
          alt="Courier Logo"
          class="courier-logo"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShippingLabel",
  props: {
    storeLogo: {
      type: String,
      required: false
    },

    /**
     * SVG del QR ya renderizado como data URI. El componente NO genera el QR;
     * el padre se encarga (ver `src/utils/qrSvg.js`). Esto desacopla la
     * responsabilidad y elimina el race condition que tenía antes con
     * `PrintShippingLabels.print()` (el watch async resolvía después del print).
     */
    qrSvg: {
      type: String,
      required: false,
      default: null
    },
    storeName: {
      type: String,
      required: true
    },

    customField1: {
      type: String,
      default: ""
    },

    customField2: {
      type: String,
      default: ""
    },

    trackingCode: {
      type: String,
      required: true
    },

    recipient: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped>
/* ============================
   CONTENEDOR
============================ */

.shipping-label-wrapper {
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding: 5mm;
}

.shipping-label {
  overflow: hidden;

  width: 100mm;
  height: 150mm;

  background: #fff;
  border: .6mm solid #000;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;

  font-family: Arial, Helvetica, sans-serif;
  color: #000;
}

/* ============================
   HEADER
============================ */

.header {
  height: 25mm;

  display: flex;
  align-items: center;

  padding: 4mm;
  box-sizing: border-box;
}

.store {
  display: flex;
  align-items: center;
  width: 100%;
}

.store-logo {
  height: 14mm;
  object-fit: contain;
  margin-right: 4mm;
}

.store-info {
  display: flex;
  flex-direction: column;
}

.store-name {
  font-size: 14pt;
  font-weight: bold;
}

.store-field {
  font-size: 8pt;
  color: #666;
}

/* ============================
   DIVIDER
============================ */

.divider {
  height: .5mm;
  background: #000;
  flex-shrink: 0;
  margin-left: 4mm;
  margin-right: 4mm;
}

/* ============================
   QR
============================ */

.qr-section {
  height: 50mm;

  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-image {
  width: 32mm;
  height: 32mm;
  object-fit: contain;
}

.tracking-code {
  font-size: 20pt;
  font-weight: bold;
}

/* ============================
   DESTINATARIO
============================ */

.recipient {
  height: 45mm;

  padding: 4mm;
  box-sizing: border-box;
  overflow: hidden;
}

.recipient-label {
  display: block;

  font-size: 7pt;
  color: #666;

  text-transform: uppercase;
  letter-spacing: .5pt;
  margin-top: 3mm;
  margin-bottom: 1mm;
}

.recipient-commune {
  display: block;

  font-size: 14pt;
  font-weight: bold;

  text-transform: uppercase;

  margin-bottom: 1mm;
}

.recipient-name {
  display: block;
  font-size: 10pt;


  font-weight: bold;

  text-transform: uppercase;
}

.recipient-text {
  display: block;

  font-size: 10pt;
  line-height: 1.35;
}

/* ============================
   FOOTER
============================ */

.footer {
  flex: 1;
  max-height: 25mm;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 4mm;
  box-sizing: border-box;
}

.footer-label {
  display: block;

  font-size: 7pt;
  color: #666;

  text-transform: uppercase;
}

.footer-title {
  display: block;

  font-size: 12pt;
  font-weight: bold;
}

.footer-user {
  display: block;

  font-size: 8pt;
  color: #666;
}

.courier-logo {
  height: 100%;
  object-fit: contain;
}

/* ============================
   IMPRESIÓN
============================ */

@page {
  size: 100mm 150mm;
  margin: 0;
}

@media print {

  html,
  body {
    margin: 0;
    padding: 0;
    background: #fff;
  }

  .shipping-label-wrapper {
    padding: 0;
    margin: 0;
    background: #fff;
  }

  .shipping-label {
    border: .6mm solid #000;
    page-break-after: always;
  }
}
</style>